import { mergeSx } from '@evrone-erp/uikit';
import { Container, useTheme } from '@mui/material';
import type { PropsWithChildren } from 'react';
import type { SxProps, Theme } from '@mui/material/styles';
import { maxHeightFlexSx } from '@shared/ui/commonSx';
type TBaseContainerProps = {
  contentPosition?: TContentPosition;
  sx?: SxProps<Theme>;
};
type TContentPosition = 'top' | 'center' | 'bottom';
const positionSx: Record<TContentPosition, string> = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end'
};
export const BaseContainer = ({
  children,
  contentPosition = 'top',
  sx
}: PropsWithChildren<TBaseContainerProps>) => {
  const theme = useTheme();
  const baseSx: SxProps<Theme> = {
    ...maxHeightFlexSx,
    justifyContent: positionSx[contentPosition],
    maxWidth: theme.breakpoints.values.desk,
    padding: '20px 15px'
  };
  return <Container sx={mergeSx(baseSx, sx)} maxWidth={false}>
      {children}
    </Container>;
};